import LocalStorageActor from './LocalStorageActor'

const localStorageKey = 'offers'

class Offer extends LocalStorageActor {
  constructor(offerId) {
    super(localStorageKey)
    this.offerId = offerId
  }

  apply(offer) {
    const offerData = this.getData([this.offerId])
    if (offerData) {
      if (offerData.offerLines) {
        offerData.offerLines.forEach(({ id, unitQuantity }) => {
          const offerLine = offer.offerLines.find(({ id: lineId }) => id === lineId)

          if (offerLine) {
            if (unitQuantity) {
              offerLine.unitQuantity = unitQuantity
            }
          }
        })
      }
    }
    return offer
  }

  update(offer) {
    const offerData = {
      offerLines: offer.offerLines.map(({ id, unitQuantity }) => {
        if (unitQuantity) {
          return {
            id,
            unitQuantity,
          }
        }
        return null
      }).filter(Boolean),
    }
    this.setData([this.offerId.toString()], offerData)
  }

  static clear() {
    LocalStorageActor.clear(localStorageKey)
  }
}

export default Offer
